import {NgModule} from '@angular/core';
import {ButtonsComponent} from './buttons.component';
import {ActionButtonComponent} from './button/action-button/action-button.component';

@NgModule({
    declarations: [
        ActionButtonComponent,
        ButtonsComponent,
    ],
    exports: [
        ActionButtonComponent,
        ButtonsComponent
    ],
    imports: []
})
export class ButtonsModule {
}
